<template>
  <div class="app-main-inner" style="flex-grow: 1;">
    <tab-customs-info-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.customsBroker.viewable && !isSalesForSzfs" slot="customsBroker" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          :disabled="readonly || !elementDict.customsBroker.writable"
          no="customsBroker"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          style="width:200px"
          :default-value="job.customsBroker||''"
          :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
          :latest-used-data-key="elementDict.customsBroker.userCustomContent && elementDict.customsBroker.userCustomContent.recentlyUsedDropdownData ? 'seaBooking-customsBroker' : ''"
          @parentCallBack="p=>{job.customsBroker=p.value||0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.advancePayment.viewable" slot="advancePayment" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.advancePayment.isRequire ? 'blue' : ''" :label="elementDict.advancePayment.label" />
        <el-select
          :value="job.advancePayment ? 1 : 0"
          :disabled="readonly || !elementDict.advancePayment.writable"
          style="width:200px"
          no="advancePayment"
          @input="val=>{job.advancePayment=!!val}"
          @change="handleAdvancePaymentChange"
        >
          <el-option
            v-for="item in SystemConstants.YESORNO_STATES"
            :key="item.code"
            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDutyAmount.viewable" slot="customsDutyAmount" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.customsDutyAmount.isRequire ? 'blue' : ''" :label="elementDict.customsDutyAmount.label" />
        <auto-number-input
          v-model="job.customsDutyAmount"
          no="customsDutyAmount"
          style="width: 200px"
          :precision="2"
          :disabled="readonly || !elementDict.customsDutyAmount.writable"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.vatAmount.viewable" slot="vatAmount" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.vatAmount.isRequire ? 'blue' : ''" :label="elementDict.vatAmount.label" />
        <auto-number-input
          v-model="job.vatAmount"
          no="vatAmount"
          style="width: 200px"
          :precision="2"
          :disabled="readonly || !elementDict.vatAmount.writable"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTime.viewable" slot="paymentTime" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.paymentTime.isRequire ? 'blue' : ''" :label="elementDict.paymentTime.label" />
        <el-date-picker
          v-model="job.paymentTime"
          no="paymentTime"
          :disabled="readonly || !elementDict.paymentTime.writable"
          type="date"
          style="width: 200px"
          clearable
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsRemarks.viewable" slot="customsRemarks" class="custom" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.customsRemarks.isRequire ? 'blue' : ''" :label="elementDict.customsRemarks.label" />
        <el-input
          v-model="job.customsRemarks"
          :disabled="readonly || !elementDict.customsRemarks.writable"
          no="customsRemarks"
          type="textarea"
          :rows="5"
          style="width:200px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.customsRemarks,val=>{job.customsRemarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.taxRemarks.viewable" slot="taxRemarks" class="custom" style="width: calc(20% - 15px);margin-right: 10px;">
        <line-label slot="label" :class="elementDict.taxRemarks.isRequire ? 'blue' : ''" :label="elementDict.taxRemarks.label" />
        <el-input
          v-model="job.taxRemarks"
          :disabled="readonly || !elementDict.taxRemarks.writable"
          no="taxRemarks"
          type="textarea"
          :rows="5"
          style="width:200px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.TaxRemarks'),job.taxRemarks,val=>{job.taxRemarks=val})"
        />
      </el-form-item>
      <template slot="customsProcedures">
        <div v-show="!previewConfig && cooperateEdit" style="display: flex;margin: 5px 0;">
          <el-button no="NewCustomsDeclaration" type="primary" :disabled="!btnEnable || (isEdit && openXhqCustomsAll)" @click="addCustInfoHandler">{{ $t('SeaExport.NewCustomsDeclaration') }}</el-button>
          <el-button no="EditCustomsDeclaration" type="primary" :disabled="!btnEnable || (isEdit && (openXhqCustoms || openXhqCustomsAll))" @click="editCustInfoHandler">{{ $t('SeaExport.EditCustomsDeclaration') }}</el-button>
          <el-button v-show="!openXhqCustomsAll" no="DeleteCustomsDeclaration" type="danger" :disabled="!btnEnable" @click="delCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          <el-button v-show="openXhqCustomsAll" v-permission="['button_customs_forceDelete']" no="xhqDeleteCustomsDeclaration" type="danger" :disabled="!btnEnable || isEdit" @click="xhqDelCustInfoHandler">{{ $t('SeaExport.DeleteCustomsDeclaration') }}</el-button>
          <el-button v-show="openXhqCustomsAll" no="xhqCustomsUnFrozen" type="primary" :disabled="!btnEnable || isEdit" @click="toXhqCustomsUnFrozenHandler">{{ $t('CargoMsg.UnFrozen') }}</el-button>
          <el-button v-show="openXhqCustoms || openXhqCustomsAll" no="GetCustomsFile" type="primary" :disabled="!btnEnable || !(job.jobState === 0) || isEdit" @click="getCustomsFile">{{ $t('SeaExport.GetFiles') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'" no="GetOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit || !$checkPermission(['button_customs_IdentifyTheCustoms'])" @click="getOcrFileHandler">{{ $t('CargoMsg.Cargo_IdentifyTheCustomsDeclaration') }}</el-button>
          <el-button v-show="closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'" no="RefreshOcrFile" type="primary" :disabled="job.jobState !== 0 || isEdit" @click="loadList">{{ $t('CargoMsg.Cargo_RefreshCustomsDeclaration') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :config-module="closeXhqCustoms ? '20240830' : '20240831'"
          :column-defs="closeXhqCustoms ? columnDefs : xhqColumnDefs"
          :row-data="rowData"
          style="flex-grow: 1;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </template>
    </tab-customs-info-UICustom-layout>
    <!-- 编辑弹框 -->
    <customs-info-dialog ref="customsInfoDialog" :customs-infos="rowData" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :visible.sync="editDialog.visible" :is-sales-for-szfs="isSalesForSzfs" :selected-customs-info="selectedCustomsInfo" :job="job" @successHandler="successHandler" @loadList="loadList" />
    <!-- 编辑弹框 欧坚 -->
    <customs-info-dialog-ouj ref="customsInfoDialogOuj" :visible.sync="editOujianDialog.visible" :selected-customs-info="editOujianDialog.customsInfo" :job="editOujianDialog.job" @successHandler="successHandler" @close="editOujianDialog.visible=false" />
    <!-- 海关回执弹窗 -->
    <customs-info-interact-res-dialog ref="customsInfoInteractResDialog" :visible.sync="interactResDialog.visible" :customs-id="interactResDialog.customsId" />
    <!-- 回执文件弹窗 -->
    <file-history-dialog ref="fileHistoryDialog" :visible.sync="fileHistoryDialog.visible" :customs-id="fileHistoryDialog.customsId" />
    <information-comparison-dialog ref="informationComparisonDialog" :visible.sync="informationComparisonDialog.visible" :data="informationComparisonDialog.data" />
    <!-- 海关回执记录弹窗 -->
    <customs-receipt-record-dialog ref="customsReceiptRecordDialog" :visible.sync="customsReceiptRecordDialog.visible" :selected-customs-info="customsReceiptRecordDialog.customsInfo" />
    <!-- 验证规则弹窗 -->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- iChannel: 3 报关, pageSource: 'customsInfo' 报关页面 -->
    <drop-uploader
      v-if="closeXhqCustoms && !openOujianCustoms && job.lob === 'SE'"
      ref="dropUploader"
      :action="URL.AIdiscern.importAndAnalyseFile"
      :upload-params="{ source: INTELLIGENT_DOCUMENT_SOURCE_9.code, iChannel: 3, jobUuid: job.uuid, pageSource: 'customsInfo', officeId: $store.getters.currentOfficeId }"
      :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','tif', 'msword', 'ms-excel', 'jpeg', 'rtf']"
      :file-format="fileFormat"
      :multiple="false"
      :open-drag="false"
      :bs-open="bsOpen"
      @upload-result="uploadResultHandler"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabCustomsInfoUICustomLayout from '@/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabCustomsInfo from '@/components/Cargo/Job/booking/tabs/tabCustomsInfo'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TabCustomsInfoUICustom',
  components: { tabCustomsInfoUICustomLayout },
  extends: tabCustomsInfo,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null // 用于调用父级的方法
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_CUSTOMS, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CUSTOMS, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateForm(form) {
      // 组件逻辑有点问题，处理一下
      if (!form.advancePayment) {
        form.advancePayment = false
      }

      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          const label = element.fieldNames.length > 1 ? field.label : element.label
          if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabCustomsInfo')
          }
        }
      }
    }
  }
}
</script>
